import { render, staticRenderFns } from "./MarkConfig.vue?vue&type=template&id=c32df36a&scoped=true"
import script from "./MarkConfig.vue?vue&type=script&lang=js"
export * from "./MarkConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32df36a",
  null
  
)

export default component.exports